module.exports = __webpack_public_path__ + "static/media/lahore-south.555cc357.svg";